import { render, staticRenderFns } from "./Lab.vue?vue&type=template&id=7cbc7654&scoped=true&"
import script from "./Lab.vue?vue&type=script&lang=ts&"
export * from "./Lab.vue?vue&type=script&lang=ts&"
import style0 from "./Lab.vue?vue&type=style&index=0&id=7cbc7654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbc7654",
  null
  
)

export default component.exports